if (!customElements.get("td-key-ingredients")) {
  class TdKeyIngredients extends HTMLElement {
    constructor() {
      super();
      this.loadMoreBtn = this.querySelector(".td-ki__load-more");
      this.loadMoreCards = this.querySelectorAll(".td-ki__load-more-cards");
      this.originalBtnText = this.loadMoreBtn ? this.loadMoreBtn.textContent : "";
      this.expanded = false;
    }

    connectedCallback() {
      if (this.loadMoreBtn && this.loadMoreCards) {
        this.loadMoreBtn.addEventListener('click', () => this.handleBtnClick());
      }
    }

    handleBtnClick() {
      this.expanded = !this.expanded;

      if (this.expanded) {
        this.loadMoreCards.forEach((card) => {
          card.classList.add("td-ki__load-more-cards--active");
        });
        this.loadMoreBtn.textContent = "See Less";
      } else {
        this.loadMoreCards.forEach((card) => {
            card.classList.remove("td-ki__load-more-cards--active");
        });
        this.loadMoreBtn.textContent = this.originalBtnText;
      }
    }
  }
  customElements.define('td-key-ingredients', TdKeyIngredients);
}
